import React, { useContext } from 'react';
import ProjectSimpleContainer from '../../../components/containers/ProjectSimpleContainer';
import { Components } from '../styled';
import useFormTextState from '../../../hooks/useFormTextState';
import { ActivityIndicatorContext } from '../../../providers/ActivityIndicatorProvider/context';
import { ToastContext } from '../../../providers/ToastProvider/context';
import { SessionContext } from '../../../providers/SessionProvider/context';
import { isProjectError } from '../../../utils/errors';
import ProjectTextField from '../../../components/inputs/ProjectTextField';

const Login = () => {
  const { setIsLoading } = useContext(ActivityIndicatorContext);
  const { showErrorToast, showWarningToast } = useContext(ToastContext);
  const { login } = useContext(SessionContext);

  const emailProps = useFormTextState();
  const passwordProps = useFormTextState();

  const onLoginPress = async () => {
    if (emailProps.value && passwordProps.value) {
      setIsLoading(true);
      const result = await login(emailProps.value, passwordProps.value);
      setIsLoading(false);
      const resultError = isProjectError(result);
      if (resultError) {
        showErrorToast(resultError);
      }
    } else {
      showWarningToast('Please enter both the email and the password and try again.');
    }
  };

  return (
    <ProjectSimpleContainer>
      <Components.Container>
        <Components.RightSideWrapper>
          <Components.RightSideHeaderWrapper>
            <Components.HeaderTitle>Alux Admin</Components.HeaderTitle>
          </Components.RightSideHeaderWrapper>
          <Components.RightSideContentWrapper>
            <Components.FieldWrapper>
              <Components.FieldLabel>Email</Components.FieldLabel>
              <ProjectTextField
                submitOnEnter={onLoginPress}
                value={emailProps.value}
                onChangeText={emailProps.onChangeText}
                inputType={'email'}
                placeholder={'Enter email address'}
              />
            </Components.FieldWrapper>
            <Components.PasswordFieldWrapper>
              <Components.FieldWrapper>
                <Components.FieldLabel>Password</Components.FieldLabel>
                <ProjectTextField
                  submitOnEnter={onLoginPress}
                  value={passwordProps.value}
                  onChangeText={passwordProps.onChangeText}
                  placeholder={'Enter password'}
                  secureTextEntry
                />
              </Components.FieldWrapper>
            </Components.PasswordFieldWrapper>
            <Components.CallToActionWrapper>
              <Components.CallToActionButton onClick={onLoginPress}>Login</Components.CallToActionButton>
            </Components.CallToActionWrapper>
          </Components.RightSideContentWrapper>
        </Components.RightSideWrapper>
      </Components.Container>
    </ProjectSimpleContainer>
  );
};

export default Login;
